import React from "react";
import PropTypes from "prop-types";

import DigiFormField from "./DigiFormField";
import DigiFormSelect from "./DigiFormSelect";

const emptySignatureField = () => ({
  _id: new Date().getTime(),
  name: "Signer",
  required: false,
  _destroy: false,
});

const Signature = ({
  index,
  signature,
  fieldErrors,
  onChange,
  onDelete
}) => (
  <div className="form-divider">
    <div className="row">
      <div className="col-xs-12 col-md-6">
        <DigiFormField
          key={`name${index}`}
          name="name"
          label="Label"
          value={signature.name || ""}
          required={true}
          fieldErrors={!signature.name && fieldErrors["custom_form_signatures.name"]
              ? fieldErrors["custom_form_signatures.name"]
              : null
          }
          type={"text"}
          onChange={e => onChange(e.target.value, index, "name")}
        />
      </div>

      <div className="col-xs-12 col-md-3">
        <DigiFormSelect
          _key={0}
          _val={1}
          key={`required${index}`}
          label="Required"
          value={signature.required}
          options={[["Yes", true], ["No", false]]}
          onChange={e => onChange(e.target.value, index, "required")}
        />
      </div>

      <div className="col-xs-12 col-md-3">
        <a
          href="javascript:void(0);"
          className="btn btn-text certification-btn-fix"
          onClick={() => {
            onDelete(index);
          }}
        >
          REMOVE SIGNATURE
        </a>
      </div>
    </div>
  </div>
);

class DigiFormSignaturesFields extends React.Component {
  state = {
    loading: false,
    fieldErrors: {},
    signatures: this.props.value
  };

  componentWillReceiveProps(newProps) {
    if(this.props != newProps) {
      this.setState({
        fieldErrors: newProps.fieldErrors
      });
    }
  }

  render() {
    const {
      loading,
      signatures,
      fieldErrors
    } = this.state;

    const {
      formName,
      onChange
    } = this.props;

    return (
      <div>
        <div className="form-divider">
          <h4>Signatures</h4>
        </div>

        {signatures.map((signature, index) => (
          signature._destroy ? null : (
            <Signature
              key={index}
              index={index}
              signature={signature}
              fieldErrors={fieldErrors}
              onChange={this.handlerChangeSignature}
              onDelete={this.handlerDeleteSignature}
            />
          ))
        )}

        <div>
          <a
            href="javascript:void(0);"
            className="btn btn-text"
            onClick={this.handlerAddSignature}
          >
            ADD SIGNATURE
          </a>
        </div>
      </div>
    );
  }

  handlerChangeSignature = (value, index, key) => {
    const signatures = this.state.signatures;
    signatures[index][key] = value;

    this.setState({ signatures: signatures, fieldErrors: {} });
    this.props.onChange(signatures, this.props.associationName);
  };

  handlerAddSignature = () => {
    const signatures = this.state.signatures;
    signatures.push(emptySignatureField(this.state.signatures.length +  1));

    this.setState({ signatures: signatures });
    this.props.onChange(signatures, this.props.associationName);
  };

  handlerDeleteSignature = index => {
    const signatures = this.state.signatures;

    if (signatures[index].id) {
      signatures[index]._destroy = true;
    } else {
      signatures.splice(index, 1);
    }

    this.setState({ signatures: signatures });
    this.props.onChange(signatures, this.props.associationName);
  };
}

DigiFormSignaturesFields.propTypes = {
  signatures: PropTypes.array,
  fieldErrors: PropTypes.object,
};

export default DigiFormSignaturesFields;
